import { GetDealResponse } from '@spilca/order_ts/v1/order/model_deal_pb';
import { useQuery } from '@tanstack/react-query';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { QUERY_KEYS } from '@monorepo/helpers';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetDeal = (id: number) => {
  const requestPromise = useGetRequest(REQUEST_TYPES.GET_DEAL);

  const request = () => requestPromise(id);

  return useQuery<GetDealResponse.AsObject, TGRPCPromiseReject>({
    queryKey: [QUERY_KEYS.ORDER, id],
    queryFn: request,
    gcTime: 1000000,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  });
};

export default useGetDeal;
